import { render, staticRenderFns } from "./freightOrder.vue?vue&type=template&id=2dea00a0&scoped=true"
import script from "./freightOrder.vue?vue&type=script&lang=js"
export * from "./freightOrder.vue?vue&type=script&lang=js"
import style0 from "./freightOrder.vue?vue&type=style&index=0&id=2dea00a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dea00a0",
  null
  
)

export default component.exports